import { BaseView } from "./base-view.js";
import { UISchema, UIFieldViewer } from "@bonusmap/api-types";
import { retrieveAmbito } from "./helper-ambito_territoriale.js";
import { retrieveCategories } from "./helper-categories.js";
import { retrieveFiles } from "./helper-files.js";
import { retrieveOrganization } from "./helper-organization.js";
import { retrieveParameters } from "./helper-parameters.js";
import { retrieveEroganti } from "./helper-eroganti.js";
import { nlToBr } from "../../utils/nl-to-br.js";

export class BonusView extends BaseView {
    static webComponentName: string = "bonus-view";
    static observedAttributes = []; // Nessun attributo da osservare per ora
    protected _templateId: string = "bonus-view";
    constructor() {
        super();
    }

    protected async buildRenderingData(): Promise<Record<string, any>> {
        const dataSource = this.dataSource;
        // trasforma dataSource svolgendo gli helper necessari
        if (dataSource.ambito_territoriale) {
            dataSource.ambito_territoriale.value = await retrieveAmbito(dataSource, 'ambito_territoriale');
        }
        // categories
        if (dataSource.categories) {
            dataSource.categories.value = await retrieveCategories(dataSource, 'categories');
        }
        if (dataSource.eroganti) {
            dataSource.eroganti.value = await retrieveEroganti(dataSource, 'eroganti');
        }
        if (dataSource.organization_id) {
            dataSource.organization_id.value = retrieveOrganization(dataSource, 'organization_id');
        }
        if (dataSource.parameters) {
            dataSource.parameters.value = await retrieveParameters(dataSource, 'parameters');
        }
        if (dataSource.files) {
            dataSource.files.value = await retrieveFiles(dataSource, 'files');
        }
        // qui occorre un oggetto semplificato per il rendering ricavato da dataSource
        // con i soli dati utili per il rendering
        const renderingData = this.extractRenderingData(dataSource);
        return {
            dataSource: this.dataSource,
            nlToBr, // funzione di utilità per il template
            data: renderingData,
            ...renderingData // qui rendo direttamente accessibili i campi 
        };
    }

    /**
     * Estrae i dati utili per il rendering dal dataSource trasformato
     * Crea un oggetto semplificato con campi viewer-specific
     */
    private extractRenderingData(dataSource: UISchema): Record<string, UIFieldViewer> {
        const renderingData: Record<string, UIFieldViewer> = {};

        // Estrai i campi necessari per il viewer
        Object.keys(dataSource).forEach(fieldName => {
            const field = dataSource[fieldName];
            if (field && field.value !== undefined) {
                renderingData[fieldName] = {
                    name: field.name,
                    label: field.label || field.name, // label obbligatorio per viewer
                    description: field.description,
                    value: field.value
                };
            }
        });

        return renderingData;
    }

    afterRender() {
        const bonusTitle = this.dataSource.title?.value || 'Bonus senza titolo';
        document.title = bonusTitle;
        this.setupPrintButton();
    }

    private setupPrintButton() {
        const printButton = this.roleElementSelector("print-page");
        if (printButton && !printButton.hasAttribute('data-print-listener')) {
            printButton.addEventListener("click", () => {
                window.print();
            });
            printButton.setAttribute('data-print-listener', 'true');
        }
    }

} 